<template>
   <div  style="display: flex"> 
    <Form class="pl-8" :model="formData" :label-width="50"  :rules="formRules" :ref="`addroom${index}`" inline>
     
        <FormItem :label-width="90" label="房间／床位号" prop="houseNumber">
            <Input size="small" class="input-item" v-model="formData.houseNumber" ></Input>
        </FormItem>      
        <FormItem v-if="isUpdate" :label-width="70" label="房间状态" prop="houseStockStatus">
            <Select size="small" v-model="formData.houseStockStatus" class="selected-item" :disabled="status===1">
                <Option value=''>请选择</Option>
                <Option v-for="item in stockStatusEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
        </FormItem>

        <FormItem label="类型" prop="houseStockType">
            <Select size="small" v-model="formData.houseStockType" class="selected-item" @on-change="changeType" :disabled="status===1">
                <Option value=''>请选择</Option>
                <Option v-for="item in stockTypeEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
        </FormItem>
      
          <FormItem label="面积" v-if="formData.houseStockType !==1" prop="houseArea" >
            <Input size="small" v-model="formData.houseArea" class="input-item append"  :number="true">
            <span slot="append">㎡</span>
            </Input>
          </FormItem>
       
         <FormItem label="朝向" v-if="formData.houseStockType !==1" prop="houseDirection">
            <Select size="small" v-model="formData.houseDirection" class="selected-item" >
                <Option value="">请选择</Option>
                <Option v-for="item in directionHouseEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
        </FormItem>
        <FormItem :label-width="70" class="w-8" label="出租价格" prop="houseRentPrice">
            <Input size="small" class="append-l" v-model="formData.houseRentPrice" :number="true">
             <span slot="append">元／月</span>
            </Input>
        </FormItem>
        <!-- <FormItem label="长租优惠价" prop="stockRentDiscontPrice">
            <Input size="small" v-model="formData.stockRentDiscontPrice" :number="true">
                <span slot="append">元／月</span>
            </Input>
        </FormItem>
        <FormItem label="生效时间" prop="discountPriceDate">
            <DatePicker class="block" type="daterange" style="margin-right: 10px;width: 300px;" split-panels placeholder="生效时间" v-model="discountPriceDate" @on-change="getdiscountPriceDate"></DatePicker>
        </FormItem> -->
        <long-term-set-price ref="addroomLongTermPrice"></long-term-set-price>
    </Form>
    <!-- <Icon v-if ="index !== 0 ||( isUpdate===true && type ===1)" class="delete-icon" size="18" color="#F56356" type="android-remove-circle" @click.native="deleteItem"></Icon> -->
    <Icon v-if ="showDelete" class="delete-icon" size="18" color="#F56356" type="android-remove-circle" @click.native="deleteItem"></Icon>

    </div>
</template>
 
<script type="text/ecmascript-6">
import { getContract } from 'api/archives'
import LongTermSetPrice from './components/LongTermSetPrice';
export default {
    props: {
      type:{
          type:Number,
          default:1
      },
      isUpdate:{
        type:Boolean,
        default:false
      },
      index: {
        type:Number,
        default:1
      },
      stockTypeEnums:{
        type:Array,
        default:[]
      },
      directionHouseEnums:{
        type:Array,
        default:[]
      },
      stockStatusEnums:{
        type:Array,
        default:()=>{
            return []
        }
      },
      isUpdate:{
          type:Boolean,
          default:false
      },
      stockData :{
          type:Object,
          default: null
      }
    },
    computed: {
      showDelete() {
        let show = false
        if(this.isUpdate){
            if(this.type === 0) {
              show = this.status === 1 ? false : (this.index ===0 ? false :true)           
            }else{
                show = true
            }
        } else {
          show = this.index===0 ? false : true
        }
        return show
      }

    },
    components: {
      LongTermSetPrice
    },
    watch: {
      stockData: {
          deep:true,
          handler(val){
            console.log(val)
            // this.formData = val
            for(let key in this.formData) {
                this.formData[key] = val[key]
            }
            this.status = val.houseStockStatus
            if(!val.discountBeginTime){
                this.discountPriceDate = ['','']
            } else {
                this.discountPriceDate = [val.discountBeginTime,val.discountEndTime]
            }
             // console.log(this.status)
            this.$refs.addroomLongTermPrice.setDiscountPriceDtoList(this.formData.discountPriceDtoList)
          }      
      }
    },
    created(){
        this.formData.discountBeginTime = ''
        this.formData.discountEndTime = ''
       if(this.type === 0) {
           for(let key in this.formData) {
                this.formData[key] = this.stockData[key]
            }
            this.status = this.stockData.houseStockStatus 
           // this.formData = this.stockData
           this.$nextTick(() => {
             this.$refs.addroomLongTermPrice.setDiscountPriceDtoList(this.formData.discountPriceDtoList)
           })
          
       }
    },
    data () {
        const validateNum = (rule, value, callback) => {
          if(!value || value <= 0 || typeof value === 'string'){
            callback(new Error(' '));
          }
          callback();
        }
        return {
         status:'',
         discountPriceDate: ['',''],
          formData:{
              fid:'',
              houseNumber:"",
              houseStockStatus:"",
              houseStockType:"",
              houseArea:"",
              houseDirection:"",
              houseRentPrice:""  ,
              stockRentDiscontPrice:"",
              discountBeginTime:"",
              discountEndTime:"",
              stockFid: "",
              discountPriceDtoList:[]
          },
          formRules:{
              houseNumber:[
                { required: true, message:' ' ,trigger: 'blur',type:'string'}
              ],
              houseStockType:[
                {required:true, message: ' ', trigger: 'change',type:'number'}
              ],
              houseStockStatus:[
                   {required:true, message: ' ', trigger: 'change',type:'number'}
              ],
              houseArea:[
                  { required: true,  validator:validateNum , trigger: 'blur'}
              ],
              houseDirection:[
                  { required: true, message: ' ' ,trigger: 'change', type:'number'}
              ],
              houseRentPrice:[
                  { required: true,  validator:validateNum  ,trigger: 'blur'}
              ]
          }
        }
    },
    methods: {
      changeType(value){
        this.formData.discountBeginTime = ''
        this.formData.discountEndTime = ''
        this.discountPriceDate =['',''];
        if(value === 1) {
            this.formData.houseArea = ''
            this.formData.houseDirection = ''
        }
      },
      getdiscountPriceDate(val){
          this.formData.discountBeginTime = val[0]
          this.formData.discountEndTime = val[1]
      },
      formValidate() {     
          let obj = {}
          this.$refs[`addroom${this.index}`].validate( bool => {
              if(bool && this.$refs.addroomLongTermPrice.validateSubmit()){ 
                  this.formData.discountPriceDtoList = this.$refs.addroomLongTermPrice.submitDiscountPriceDtoList()
                  obj = this.formData
              }else{
                  console.log('fail')
                  obj = false
              }
          })
          return obj
      },
      deleteItem(){
        let stockFid = this.formData.stockFid ? this.formData.stockFid :''
        let data = {
            stockFid:this.formData.stockFid,
            type: this.type,
            index: this.index
        }
       this.$emit('delete-item',data)
      }
    }
}
</script>
<style scoped>
.input-item {
  width: 60px;
}
.selected-item {
  width: 80px;
}
.append {
    width: 70px;
    padding-top: 3px;
}
.append-l {
    width: 100px;
}
</style>
